import { Box, FlexBox, BoxImage } from "../../common/Box"
import TYPOGRAPHY from "../../../themes/Typography"
import { px2Rem } from "../../../themes/Mixins"
import COLORS from "../../../themes/Colors"
import IMAGE from "../../../themes/Image"
import Title from "../../common/Title"

const BtnNav = `
  width: ${px2Rem(45)};
  height: ${px2Rem(45)};
`

export const BtnNext = `
  @media (min-width: 768px) {
    ${BtnNav}
    right: 3%;
  }
`

export const BtnPrev = `
  @media (min-width: 768px) {
    ${BtnNav}
    left: 3%;
  }
`

export const Wrapper = Box.extend`
  position: relative;
  min-height: ${px2Rem(230)};
  padding: ${px2Rem(30)} 0;

  @media (min-width: 768px) {
    min-height: ${px2Rem(356)};
    margin-bottom: ${px2Rem(5)};
    padding: ${px2Rem(50)} 0 ${px2Rem(80)};
  }
`

export const WrapperTitle = FlexBox.extend`
  flex-wrap: wrap;
  padding: 0 3%;
  margin: 0 0 ${px2Rem(15)};

  @media (min-width: 768px) {
    padding: 0 7%;
  }
`

const Quote = `
  margin: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  width : ${px2Rem(38)};
  height: ${px2Rem(34)};
`

const QuoteDesktop = `
  @media (min-width: 768px) {
    width: ${px2Rem(98)};
    height: ${px2Rem(86)};
  }
`

export const QuoteLeft = BoxImage.extend`
  ${Quote}
  background-image: url(${IMAGE.quoteLeft});

  @media (min-width: 768px) {
    ${QuoteDesktop}
  }
`

export const MainTitle = Title.extend`
  color: ${COLORS.white};
  font-family: ${TYPOGRAPHY.TYPE.light};
  font-size: ${px2Rem(28)};
  margin: ${px2Rem(8)} 0 0;

  @media (min-width: 768px) {
    margin: ${px2Rem(20)} 0 0;
    font-size: ${px2Rem(35)};
    width: 100%;
  }
`

export const QuoteRight = BoxImage.extend`
  ${Quote}
  background-image: url(${IMAGE.quoteRight});
  position: absolute;
  right: 3%;
  bottom: ${px2Rem(30)};

  @media (min-width: 768px) {
    ${QuoteDesktop}
    right: 7%;
    bottom: ${px2Rem(120)};
  }
`




// WEBPACK FOOTER //
// ./src/components/sections/testimonial/TestimonialsResponsive.js